export const handleValidationChange = (name, value, setIsError) => {
    setIsError(prevState => ({
        ...prevState,
        [name]: value
    }));
}
